export const PRESCRIBED_MEDICATION_CONSENT_CODE = "MEDICATIONS";
